<mat-expansion-panel expanded>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'AUXILIARY_DATA_CARD.CARD_TITLE' | translate }}
    </mat-panel-title>
    <mat-panel-description>
      <a
        data-action="clicked-manage-custom-fields-data-card"
        mat-stroked-button
        [href]="auxiliaryDataAdminURL"
        *ngIf="auxiliaryDataAdminURL"
      >
        {{ 'COMMON.MANAGE_ATTRIBUTES' | translate }}
      </a>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-container *ngIf="fieldHandlers$ | async as fieldHandlers; else loadingState">
    <form *ngIf="(loadingStatus$ | async) === LoadingStatus.OK" [formGroup]="formGroup" class="aux-data-card-form">
      <ng-container *ngFor="let handler of fieldHandlers">
        <aux-renderer-selector [handler]="handler"></aux-renderer-selector>
      </ng-container>
    </form>
  </ng-container>
  <ng-container>
    <button
      (click)="saveChanges()"
      mat-flat-button
      [disabled]="formGroup.invalid || formGroup.pristine || (savingStatus$ | async) === SavingStatus.SAVING"
      color="primary"
      type="button"
      data-testid="save-button"
      class="aux-data-card-button"
    >
      <glxy-button-loading-indicator [isLoading]="(savingStatus$ | async) === SavingStatus.SAVING">
        {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
      </glxy-button-loading-indicator>
    </button>
  </ng-container>
</mat-expansion-panel>

<ng-template #loadingState>
  <ng-container *ngIf="(loadingStatus$ | async) === LoadingStatus.LOADING">
    <div class="loading-container">
      <mat-spinner diameter="24" strokeWidth="2"></mat-spinner>
    </div>
  </ng-container>

  <glxy-empty-state *ngIf="(loadingStatus$ | async) === LoadingStatus.ERROR">
    <glxy-empty-state-hero>
      <mat-icon>report_problem</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ 'AUXILIARY_DATA_CARD.ERROR.TITLE' | translate }}
    </glxy-empty-state-title>
    <p>{{ 'AUXILIARY_DATA_CARD.ERROR.TEXT' | translate }}</p>
    <glxy-empty-state-actions></glxy-empty-state-actions>
  </glxy-empty-state>
</ng-template>
